import React from 'react';
import classes from './AsttButtonDark.module.css';

const AsttButtonDark = props => {
    return (
        <button  onClick={props.onClick} className={classes.button} type={props.type || 'button'}>{props.children}</button>
    )
}


export default AsttButtonDark;